import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import { AuthenticationService, ExRateService, StorageService } from './services/index';
import {ApplicationTabsService} from "./services/application-tabs.service";
import {Observable} from "rxjs";
import {setSentryUser} from "./services/sentry";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Cavisco Supermercado';
  currentUser: any;
  shouldLockTab: Observable<boolean>;
  constructor(
      private router: Router,
      private authenticationService: AuthenticationService,
      private exRateService: ExRateService,
      private storageService: StorageService,
      private applicationTabsService: ApplicationTabsService
  ) {
    this.authenticationService.currentUser.subscribe(x => {
      this.currentUser = x;
      // Cubre login, logout y recarga de pagina: el BehaviorSubject se inicializa con la sesion
      // guardada en localStorage y emite null cuando se cierra sesion.
      setSentryUser(x);
    });
  }

  ngOnInit(): void {
    this.shouldLockTab = this.applicationTabsService.ShouldLockWindow;

    if (!this.storageService.getCurrentSession() !&& this.storageService.getCurrentSessionOffline()) {
      this.logout();
    }

  }

  logout(): void {
    this.storageService.logout();
    this.router.navigate(['/login']);
  }
}
